 import { useContext, useState, useRef, useEffect } from "react";
import { LanguageContext } from "../contexts/LanguageContext";
import { ChevronDown } from "lucide-react";

export default function LanguageSwitcher() {
  const { language, setLanguage } = useContext(LanguageContext);
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  const langs = [
    { code: "et", name: "Eesti", flag: "🇪🇪" },
    { code: "en", name: "English", flag: "🇬🇧" },
  ];

  const currentLang = langs.find((l) => l.code === language) || langs[0];

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="relative inline-block text-left" ref={dropdownRef}>
      {/* Selected language button */}
      <button
        onClick={() => setOpen(!open)}
        className="flex items-center gap-2 px-3 py-2 bg-zinc-600 rounded-xl border border-gray-500 hover:bg-gray-100 transition"
        aria-haspopup="listbox"
        aria-expanded={open}
      >
        <span className="text-xl">{currentLang.flag}</span>
        {/* <span className="font-medium">{currentLang.name}</span> */}
        <ChevronDown
          className={`w-4 h-4 ml-1 transition-transform ${
            open ? "rotate-180" : ""
          }`}
        />
      </button>

      {/* Dropdown menu */}
      {open && (
        <ul
          className="absolute mt-2 rounded-xl w-40 bg-white border border-gray-200  shadow-lg z-10"
          role="listbox"
        >
          {langs.map((l) => (
            <li
              key={l.code}
              className={`flex items-center  px-3 py-2 rounded-xl cursor-pointer hover:bg-gray-100 ${
                language === l.code ? "bg-gray-100 font-semibold" : ""
              }`}
              onClick={() => {
                setLanguage(l.code);
                setOpen(false);
              }}
              role="option"
              aria-selected={language === l.code}
            >
              <span className="text-xl">{l.flag}</span>
             
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
